import { useParseQueryString, usePrevious, useQueryNavigate } from '@/hooks';
import { QueryParams } from '@/interfaces';
import { CustomInput, Icon } from '@amili-v3/amili-v3-design';
import classNames from 'classnames';
import _debounce from 'lodash/debounce';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';

const SearchInput = () => {
  const { t } = useTranslation();
  const handleNavigate = useQueryNavigate();
  const qsParams = useParseQueryString<QueryParams>();

  const [searchValue, setSearchValue] = useState<string>(qsParams?.q || '');
  const preValue = usePrevious(qsParams?.q);

  useEffect(() => {
    if (!!preValue && !qsParams?.q) setSearchValue('');
    if (qsParams?.q) setSearchValue(qsParams?.q);
  }, [preValue, qsParams?.q]);

  const debouncedSearchValue = useMemo(
    () =>
      _debounce(value => {
        return !!value
          ? handleNavigate({ q: value.trim(), page: 1 })
          : handleNavigate({ page: 1 }, ['q']);
      }, 500),
    [handleNavigate],
  );

  const handleChange = (value: string) => setSearchValue(value);

  return (
    <CustomInput
      aria-label="search-input"
      prefix={
        <Icon name="search" width={16} height={16} color="var(--primary)" />
      }
      height={32}
      value={searchValue}
      placeholder={(t('common.search') as string) + '...'}
      onChange={e => {
        handleChange(e.target.value);
        debouncedSearchValue(e.target.value);
      }}
      // onPressEnter={() => handleNavigate({ q: searchRef.current })}
      className={classNames('search-input')}
      allowClear
    />
  );
};

export default SearchInput;
